import { ReactElement } from "react";

import { ExternalLink } from "~frontend/components/Link";

import ScriptAlert from "./ScriptAlert";

const SHAFT_PHRASES = [
  "aroused",
  "arousal ",
  "pussy",
  "sextoy",
  "dildo",
  "sensual",
  "sexual",
  "orgasm",
  "ale",
  "bar",
  "beer",
  "bootleggers",
  "booze",
  "bourbon",
  "brandy",
  "brewpub",
  "brewery",
  "champagne",
  "cocktail",
  "elixir",
  "gin",
  "intoxicant",
  "kegs",
  "lager",
  "liqueur",
  "liquor",
  "microbrew",
  "mixed drink",
  "mixer",
  "moonshine",
  "pale ale",
  "pale lager",
  "pub",
  "rum",
  "saloon",
  "schnapps",
  "seltzer",
  "spirits",
  "tavern",
  "tequila",
  "vodka",
  "whiskey",
  "whisky",
  "wine",
  "ammo",
  "ammunition",
  "artillery ",
  "ar",
  "ars",
  "bullet",
  "handgun",
  "musket",
  "pistol",
  "revolver",
  "rifle",
  "shot",
  "shotgun",
  "420",
  "4/20",
  "bong",
  "cannabis",
  "cbd",
  "cigar",
  "cigarette",
  "e-cigarette",
  "gummy",
  "gummies",
  "hemp",
  "hookah",
  "marijuana",
  "nicotine",
  "pot",
  "smoke",
  "tobacco",
  "thc",
  "kush",
  "hashish ",
  "ganja",
  "caliva",
  "sativa",
  "canna",
  "vape",
  "weed",
  "bet",
  "bingo",
  "blackjack",
  "jackpot",
  "lottery",
  "lotto",
  "poker",
  "raffle",
  "roulette",
  "slot",
  "sweepstakes",
  "prank",
];

const SHAFT_REGEX = new RegExp(
  SHAFT_PHRASES.map(p => `\\b${p}\\b`).join("|"),
  "i"
);

export default function ShaftWarnings({
  renderedMessage,
}: {
  renderedMessage: string;
}): ReactElement | null {
  const shaftPhraseMatch = SHAFT_REGEX.exec(renderedMessage);
  if (!shaftPhraseMatch) {
    return null;
  }

  return (
    <ScriptAlert severity="warning">
      <strong>Warning:</strong> Your script contains the word &ldquo;
      {shaftPhraseMatch[0]}&rdquo;, which may impact deliverability. Phone
      carriers sometimes block messages containing words that{" "}
      <ExternalLink href="https://scaletowin.freshdesk.com/support/solutions/articles/66000529481">
        relate to S.H.A.F.T topics.
      </ExternalLink>
    </ScriptAlert>
  );
}
